import {KPI, KPIGroupKey} from '../kpi';
import {DateUtils} from './DateUtils';
import {DateRange} from '../stores/TimeIntervalStore';

export const serializeDate = (data: any): any => {
    const dataCopy = {...data};
    Object.keys(dataCopy).forEach((dataKey) => {
        if (DateUtils.isDateRange(dataCopy[dataKey])) {
            dataCopy[dataKey] = serializeDateRange(dataCopy[dataKey]);
        }
    });
    return dataCopy;
};

export const serializeDateRange = (dateRange: DateRange): string => {
    if (DateUtils.isDateRange(dateRange)) {
        return dateRange.startDate.format('YYYY-MM-DDTHH:mm:ss') + '/' + dateRange.endDate.format('YYYY-MM-DDTHH:mm:ss');
    }
    return '';
};

type ExtractPropertyNames<T, Condition> = {[K in keyof T]: T[K] extends Condition ? K : never}[keyof T];

export const serialize = <T>(data: T, dateRangeKeys: Array<ExtractPropertyNames<T, DateRange>>): any => {
    const dataCopy: any = {...data};
    dateRangeKeys.forEach((dataKey) => {
        dataCopy[dataKey] = dataCopy[dataKey].startDate.format('YYYY-MM-DDTHH:mm:ss') + '/' + dataCopy[dataKey].endDate.format('YYYY-MM-DDTHH:mm:ss');
    });
    return dataCopy;
};

export const formatSorting = (data: any): any => {
    if (data.sorting && data.sorting.attribute && data.sorting.sortDirection) {
        return {
            ...data,
            sortDirection: data.sorting.sortDirection.toLowerCase(),
            sortAttribute:
                typeof data.sorting.attribute === 'string'
                    ? partiallyConvertToSnakeCase(convertToDBAttributeIfNecessary(data.sorting.attribute))
                    : data.sorting.attribute,
        };
    }
    return data;
};

// Some attributes are called differently in the backend and need to be switched before request sending
const convertToDBAttributeIfNecessary = (attribute: KPI | KPIGroupKey): string => {
    if (attribute === 'searchterm') {
        return 'query';
    }
    return attribute;
};

// converts everything after the last . in the string to camelCase.
export const partiallyConvertToSnakeCase = (text: string): string => {
    const textSplit = text.split('.');
    const camelCaseAttribute = textSplit[textSplit.length - 1];
    return text.replace(camelCaseAttribute, convertCamelCaseToSnakeCase(camelCaseAttribute));
};

export const convertCamelCaseToSnakeCase = (text: string): string => {
    const textSplit = text.split('.');
    const camelCaseAttribute = textSplit[textSplit.length - 1];
    const snakeCaseAttribute = camelCaseAttribute
        .split(/(?=[A-Z])/)
        .join('_')
        .toLowerCase();
    return text.replace(camelCaseAttribute, snakeCaseAttribute);
};



// WEBPACK FOOTER //
// ./src/utility/ApiParamConversion.ts